import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    Stack,
    Chip,
    IconButton,
    Fade,
    Box,
    Paper,
    Alert
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useDispatch, useSelector } from "react-redux";
import { getPrkStats } from "../../Slices/competencePaths";
import { useNavigate } from "react-router-dom";



const ReportCard = ({ report, onClick }) => (
    <Card
        onClick={onClick}
        sx={{
            cursor: "pointer",
            borderRadius: 3,
            transition: "all 0.25s ease",
            "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: 6
            },
            backgroundColor: '#294e6b',
            color: "#fff"
        }}
    >
        <CardContent>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <CalendarTodayIcon fontSize="small" />
                        <Typography fontWeight={600}>
                            {report.periodLabel}
                        </Typography>
                    </Stack>

                    <Typography variant="body2" color="#e6e6e6ff">
                        {report.title}
                    </Typography>
                </Grid>

                <Chip
                    label={report.status}
                    color={
                        report.status === "Wygenerowany"
                            ? "success"
                            : "warning"
                    }
                    size="small"
                />
            </Grid>
        </CardContent>
    </Card>
);



const ReportsBox = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth.accessToken);

    const [selectedReport, setSelectedReport] = useState(null);

    useEffect(() => {
        // dispatch(getPrkStats(token));
    }, [dispatch, token]);


    const reports = [
        {
            id: "344",
            category: "monthly",
            periodLabel: "Luty 2026",
            date: "01.02.2026",
            title: "Raport miesięczny – Luty 2026",
            description:
                "Szczegółowa analiza postępów użytkownika wraz z oceną",
            status: "Wygenerowany"
        },
        {
            id: "744",
            category: "monthly",
            periodLabel: "Marzec 2026",
            date: "01.03.2026",
            title: "Raport miesięczny – Marzec 2026",
            description:
                "Szczegółowa analiza postępów użytkownika wraz z oceną",
            status: "Wygenerowany"
        },
        {
            id: "1144",
            category: "monthly",
            periodLabel: "Kwiecień 2026",
            date: "01.04.2026",
            title: "Raport miesięczny – Kwiecień 2026",
            description:
                "Szczegółowa analiza postępów użytkownika wraz z oceną",
            status: "Wygenerowany"
        },
        {
            id: "1430",
            category: "monthly",
            periodLabel: "Maj 2026",
            date: "01.05.2026",
            title: "Raport miesięczny – Maj 2026",
            description:
                "Szczegółowa analiza postępów użytkownika wraz z oceną",
            status: "Oczekuje"
        },
        {
            id: "Q1-2026",
            category: "quarterly",
            periodLabel: "I Kwartał 2026 (Q1)",
            dateRange: "1 stycznia – 31 marca 2026",
            months: ["styczeń", "luty", "marzec"],
            title: "Raport kwartalny – Q1 2026",
            description:
                "Podsumowanie wyników i postępów za pierwszy kwartał 2026 roku.",
            status: "Wygenerowany"
        },
        {
            id: "Q2-2026",
            category: "quarterly",
            periodLabel: "II Kwartał 2026 (Q2)",
            dateRange: "1 kwietnia – 30 czerwca 2026",
            months: ["kwiecień", "maj", "czerwiec"],
            title: "Raport kwartalny – Q2 2026",
            description:
                "Analiza kompetencji i realizacji celów za drugi kwartał 2026 roku.",
            status: "Oczekuje"
        }
    ];


    const monthlyReports = reports.filter(r => r.category === "monthly");
    const quarterlyReports = reports.filter(r => r.category === "quarterly");





    const handleGoToReport = (id) => {
        navigate(`/report/${id}`);
    };

    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                borderRadius: 4,
                minHeight: 260,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            }}
        >
            <Fade in timeout={300}>
                <Box>

                    {!selectedReport && (
                        <>
                            <Typography variant="h6" fontWeight={600} mb={3} sx={{ color: "#0009", justifySelf: 'center' }}>
                                Raporty
                            </Typography>

                            {monthlyReports.length > 0 && (
                                <>
                                    <Typography variant="subtitle2" color="text.secondary" mb={1}>
                                        Raporty miesięczne
                                    </Typography>

                                    <Stack spacing={2} mb={3}>
                                        {monthlyReports.map((report) => (
                                            <ReportCard
                                                key={report.id}
                                                report={report}
                                                onClick={() => setSelectedReport(report)}
                                            />
                                        ))}
                                    </Stack>
                                </>
                            )}

                            {quarterlyReports.length > 0 && (
                                <>
                                    <Typography variant="subtitle2" color="text.secondary" mb={1}>
                                        Raporty kwartalne
                                    </Typography>

                                    <Stack spacing={2}>
                                        {quarterlyReports.map((report) => (
                                            <ReportCard
                                                key={report.id}
                                                report={report}
                                                onClick={() => setSelectedReport(report)}
                                            />
                                        ))}
                                    </Stack>
                                </>
                            )}
                        </>
                    )}


                    {selectedReport && (
                        <>
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                mb={2}
                            >
                                <IconButton
                                    size="small"
                                    onClick={() => setSelectedReport(null)}
                                >
                                    <ArrowBackIcon />
                                </IconButton>

                                <Typography variant="h6" fontWeight={600}>
                                    Szczegóły raportu
                                </Typography>
                            </Stack>

                            <Card sx={{ borderRadius: 3, border: 0 }} elevation={0}>
                                <CardContent>
                                    <Stack spacing={2}>
                                        <Typography variant="subtitle1" fontWeight={600}>
                                            {selectedReport.title}
                                        </Typography>

                                        {/* <Alert severity="error">Raporty nie są dostępne w ramach twojej licencji.</Alert> */}

                                        <Stack direction="row" spacing={2} flexWrap="wrap">
                                            <Chip
                                                icon={<CalendarTodayIcon />}
                                                label={
                                                    selectedReport.category === "monthly"
                                                        ? selectedReport.date
                                                        : selectedReport.dateRange
                                                }
                                                variant="outlined"
                                            />

                                            <Chip
                                                label={selectedReport.status}
                                                color={
                                                    selectedReport.status === "Wygenerowany"
                                                        ? "success"
                                                        : "warning"
                                                }
                                            />

                                        </Stack>

                                        {selectedReport.category === "quarterly" && (
                                            <Typography variant="body2" color="text.secondary">
                                                Miesiące: {selectedReport.months.join(", ")}
                                            </Typography>
                                        )}


                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            {selectedReport.description}
                                        </Typography>

                                        {selectedReport.status === "Wygenerowany" && (
                                            <Button
                                                variant="contained"
                                                startIcon={<VisibilityIcon />}
                                                // disabled
                                                onClick={() =>
                                                    handleGoToReport(selectedReport.id)
                                                }
                                                sx={{ alignSelf: "center" }}
                                            >
                                                Przejdź do raportu
                                            </Button>
                                        )}
                                    </Stack>
                                </CardContent>
                            </Card>
                        </>
                    )}

                </Box>
            </Fade>
        </Paper>
    );
};

export default ReportsBox;
